import * as React from 'react';
import { cn } from '@/lib/cn';

/** Use only where the final layout is already known (design doc §22.4). */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}
